import api from "./apiConfig";

export const REGISTER_INMUEBLE = async (data) => {
	try {
		const response = await api.post("/properties", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_INMUEBLES = async () => {
	try {
		const response = await api.get("/properties");
		return response.data;
	} catch (error) {
        console.error("Error al obtener los inmuebles:", error);
		throw error;
	}
};

export const GET_INMUEBLES_ESTATE = async (real_estate) => {
	try {
		const response = await api.get(`/properties_estate/${real_estate}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener los inmuebles:", error);
		throw error;
	}
};

export const GET_INMUEBLES_BY_USER = async (id) => {
	try {
		const response = await api.get(`/properties/user/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener los inmuebles:", error);
		throw error;
	}
};

export const GET_INMUEBLE_ID = async (id) => {
	try {
		const response = await api.get(`/properties/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el inmueble:", error);
		throw error;
	}
};

export const UPDATE_INMUEBLE = async (id, data) => {
	try {
		const response = await api.put(`/properties/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const DELETE_INMUEBLE = async (id) => {
	try {
		const response = await api.delete(`/properties/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};